const testStoryPaths = {
    accordion: "content-expandables-accordion",
    "async-html": "utilities-async-html",
    "async-modal": "content-modal-async-modal",
    "autosuggest-input": "forms-inputs-autosuggest-input",
    "bar-chart": "content-charts-bar-chart",
    checkbox: "forms-checkbox-checkbox",
    "checkbox-rules": "forms-checkbox-checkbox-rules",
    "checkbox-tile": "forms-checkbox-checkbox-tile",
    code: "content-code",
    collapsible: "content-expandables-collapsible",
    "data-ingest": "utilities-data-ingest",
    "date-picker": "forms-date-picker-date-picker",
    "date-range-picker": "forms-date-picker-date-range-picker",
    "date-time": "utilities-date-time",
    "direct-searchbox": "forms-direct-searchbox",
    "dot-pagination": "navigation-dot-pagination",
    dropdown: "forms-select-dropdown",
    "file-upload": "forms-file-upload",
    filter: "content-filters-filter",
    form: "forms-form-validation",
    "form-group": "forms-form-group",
    "guided-tour": "content-guided-tour-guided-tour",
    icon: "icons-icon",
    "info-banner": "content-info-banner",
    "input-field": "forms-inputs-input-field",
    "input-field-number": "forms-inputs-input-field-number",
    "line-chart": "content-charts-line-chart",
    "message-box": "content-infos-message-box",
    modal: "content-modal-static-modal",
    "notification-item": "content-notifications-notification-item",
    "number-format": "utilities-number-format",
    "number-input": "forms-inputs-number-input",
    "password-input": "forms-inputs-password-input",
    "phone-input": "forms-inputs-phone-input",
    "popover-panel": "content-popovers-popover-panel",
    "radio-button": "forms-radio-button-radio-button",
    "radio-list-item": "forms-select-dropdown",
    "range-input": "forms-inputs-range-input",
    redirect: "utilities-redirect",
    "scrollable-container": "content-scrollable-container",
    "scroll-to-top-button": "navigation-scroll-to-top-button",
    select: "forms-select-select",
    sidebar: "content-sidebar",
    slider: "content-slider",
    "spinner-overlay": "content-indicators-spinner-overlay",
    "static-filter": "content-filters-static-filter",
    steps: "navigation-steps",
    "switch-input": "forms-inputs-switch-input",
    table: "content-tables-table",
    "table-data": "content-tables-table-data",
    "tab-container": "navigation-tabs",
    "tab-switcher": "navigation-tabs",
    tag: "content-indicators-tag",
    "text-lines-limit": "utilities-text-lines-limit",
    "textarea-field": "forms-inputs-textarea-field",
    "toggle-button": "buttons-async-toggle-button",
    tooltip: "content-popovers-tooltip",
    video: "content-video",
    // static
    "block-hero": "content-teasers-tiles-block-hero",
    "breadcrumb-navigation": "navigation-breadcrumb-navigation",
    "button-group": "buttons-button-group",
    text: "content-text"
};

export const getTestStory = (component: string, storyName: string): string => {
    return `${
        testStoryPaths[component.toLowerCase().replace(/^ux-/, "")]
    }--${storyName.toLowerCase()}`;
};
